import { render } from "./ohmic-string-selection-modal.vue?vue&type=template&id=35d77fc7&ts=true"
import script from "./ohmic-string-selection-modal.vue?vue&type=script&lang=ts"
export * from "./ohmic-string-selection-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__